import { ResponseService } from './response.service';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Headers, Http, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { HttpRequest } from 'selenium-webdriver/http';
import { NotificationsService } from 'angular2-notifications';
import { Router } from '@angular/router';


@Injectable()
export class ApiService {

  private token: string;

  constructor(
    private http: Http,
    private responseService: ResponseService,
    private notificationService: NotificationsService,
    private router: Router
  ) {
    this.token = '';
  }

  /**
   * Zwraca nagłówki dla CORS requestow
   * 
   * @private
   * @returns {Headers} 
   * @memberof ApiService
   */
  private getHeaders(): Headers {
    const headers: Headers = new Headers();
    headers.append('content-type', 'application/json');
    headers.append('x-requested-with', 'xmlhttprequest');
    return headers;
  }


  /**
   * Formatuje błędy
   * 
   * @private
   * @param {*} error 
   * @returns {Observable<any>} 
   * @memberof ApiService
   */
  private formatErrors(error: any): Observable<any> {
    if (error.status && error.status.code === 401) {
      //this.notificationService.error('Wylogowany', 'Prosimy o ponowne zalogowanie się.');
      this.router.navigateByUrl('/login');
      return;
    }
    return Observable.throw(error.json());
  }

  public getCSRFToken(): Promise<string | Response> {
    return new Promise((resolve, reject) => {
      this.get('/csrf').subscribe(
        (response) => {
          this.token = this.responseService.success(false, response, 'csrf_token');
          resolve(this.token);
        },
        (error) => {
          this.responseService.error(error);
          reject(error);
        }
      );
    });
  }

  /**
   * Request GET
   * 
   * @param {string} path
   * @returns {Observable<any>}
   * @memberof ApiService
   */
  public get(path: string): Observable<any> {
    const options = new RequestOptions({
      headers: this.getHeaders(),
      withCredentials: true
    });

    return this.http.get(`${environment.api_url}${path}`, options)
      .catch(this.formatErrors)
      .map((res: Response) => {
        return res.json();
      });
  }

  /**
   * Request PUT
   * 
   * @param {string} path 
   * @param {Object} [body={}] 
   * @returns {Observable<any>} 
   * @memberof ApiService
   */
  public put(path: string, body: Object = {}): Observable<any> {
    const headers = this.getHeaders();
    headers.append('X-CSRF-TOKEN', this.token);

    return this.http.put(
      `${environment.api_url}${path}`,
      JSON.stringify(body),
      { headers: headers, withCredentials: true }
    )
      .catch(this.formatErrors)
      .map((res: Response) => {
        return res.json();
      });
  }

  /**
   * Request POST
   * 
   * @param {string} path 
   * @param {Object} [body={}] 
   * @returns {Observable<any>} 
   * @memberof ApiService
   */
  public post(path: string, body: Object = {}): Observable<any> {
    const headers = this.getHeaders();
    headers.append('x-csrf-token', this.token);
    return this.http.post(
      `${environment.api_url}${path}`,
      JSON.stringify(body),
      { headers: headers, withCredentials: true }
    )
      .catch(this.formatErrors)
      .map((res: Response) => {
        return res.json();
      });
  }

  /**
   * Request DELETE
   * 
   * @param {any} path 
   * @returns {Observable<any>} 
   * @memberof ApiService
   */
  public delete(path): Observable<any> {
    const headers = this.getHeaders();
    headers.append('x-csrf-token', this.token);
    return this.http.delete(
      `${environment.api_url}${path}`,
      { headers: headers, withCredentials: true }
    )
      .catch(this.formatErrors)
      .map((res: Response) => res.json());
  }

  /**
   * Request do przesyłania plików
   * @TODO nie działa :/
   * 
   * @param {string} path 
   * @param {any} body 
   * @returns {Observable<any>} 
   * @memberof ApiService
   */
  public uploadFile(path: string, body): Observable<any> {
    const headers = new Headers();
    headers.append('Content-Type', undefined);
    headers.append('Accept', 'application/json');
    headers.append('x-csrf-token', this.token);
    const options = new RequestOptions({ headers: headers, withCredentials: true })
    return this.http.post(
      `${environment.api_url}${path}`,
      body,
      options
    )
      .catch(this.formatErrors)
      .map((res: Response) => {
        return res;
      });
  }
  /**
   * Request POST
   * 
   * @param {string} path 
   * @param {Object} [body={}] 
   * @returns {Observable<any>} 
   * @memberof ApiService
   */
  public postWithFiles(path: string, formData: any): Observable<any> {
    let headers = new Headers();
    // headers.append('Content-Type', "multipart/form-data; charset=utf-8; boundary=" + Math.random().toString().substr(2));
    //headers.append('Content-Type', "application/x-www-form-urlencoded");
    headers.append('Content-Type', '');
    //headers.append('Accept', 'application/json');
    //headers.append('Content-Type', undefined);

    headers.append('x-csrf-token', this.token);
    headers.append('X-Requested-With', 'XMLHttpRequest');
    let options = new RequestOptions({ headers: headers, withCredentials: true });
    //console.log(formData);
    //formData.append('_method', 'POST');
    return this.http.post(`${environment.api_url}${path}`, formData, options).map(res => res.json())
    .catch(this.formatErrors);
    // .subscribe(
    //     data => console.log('success'),
    //     error => console.log(error)
    // );


    // return this.http.post(
    //   `${environment.api_url}${path}`,
    //   JSON.stringify(body),
    //   { headers: headers, withCredentials: true }
    // )
    //   .catch(this.formatErrors)
    //   .map((res: Response) => {
    //     return res.json();
    //   });
  }
}


// WEBPACK FOOTER //
// ./src/app/services/api.service.ts